<template>
  <div class="theme-preview-frame" :style="cssVars" aria-hidden="true">
    <div class="preview-app">
      <div class="preview-sidebar">
        <span class="preview-nav is-active"></span>
        <span class="preview-nav"></span>
        <span class="preview-nav"></span>
        <span class="preview-nav"></span>
      </div>

      <div class="preview-main">
        <div class="preview-heading">Sessions this month</div>
        <div class="preview-rule"></div>

        <div class="preview-chart">
          <span
            v-for="(bar, index) in bars"
            :key="index"
            :style="{ height: `${bar}%` }"
          ></span>
        </div>

        <div class="preview-table">
          <div class="preview-table-head">
            <span></span><span></span><span></span>
          </div>
          <div v-for="row in 2" :key="row" class="preview-table-row">
            <span></span><span></span><span></span>
          </div>
        </div>

        <div class="preview-actions">
          <span class="preview-btn-primary">Save</span>
          <span class="preview-btn-outline">Cancel</span>
          <span class="preview-link">View all</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { readableTextColorOn } from "@/utils/theme";

const PREVIEW_BARS = [45, 72, 58, 100, 81];

export default {
  name: "ThemePreview",
  props: {
    themeColor: {
      type: String,
      required: true,
    },
  },
  computed: {
    bars() {
      return PREVIEW_BARS;
    },
    cssVars() {
      return {
        "--preview-accent": this.themeColor,
        "--preview-on-accent": readableTextColorOn(this.themeColor),
      };
    },
  },
};
</script>

<style scoped lang="scss">
.theme-preview-frame {
  border: 1px solid #e3ebf6;
  border-radius: 10px;
  padding: 10px;
  background: #ffffff;
  user-select: none;
}

.preview-app {
  display: flex;
  gap: 10px;
  min-height: 190px;
}

.preview-sidebar {
  flex: 0 0 46px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 8px 6px;
  border-radius: 6px;
  background: #f3f5f9;

  .preview-nav {
    height: 7px;
    border-radius: 3px;
    background: #d8dee9;

    &.is-active {
      background: var(--preview-accent);
    }
  }
}

.preview-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.preview-heading {
  font-size: 11px;
  font-weight: 600;
  color: #3b506c;
  margin-bottom: 6px;
}

.preview-rule {
  height: 2px;
  border-radius: 1px;
  background: var(--preview-accent);
  margin-bottom: 10px;
}

.preview-chart {
  display: flex;
  align-items: flex-end;
  gap: 5px;
  height: 46px;
  margin-bottom: 10px;

  span {
    flex: 1;
    border-radius: 2px 2px 0 0;
    background: var(--preview-accent);
  }
}

.preview-table {
  margin-bottom: 10px;

  .preview-table-head,
  .preview-table-row {
    display: flex;
    gap: 6px;
    padding: 4px 0;

    span {
      height: 5px;
      border-radius: 2px;
      background: #e3e8f0;

      &:first-child {
        flex: 2;
      }
      &:nth-child(2) {
        flex: 1;
      }
      &:last-child {
        flex: 1;
      }
    }
  }

  .preview-table-head {
    border-bottom: 1px solid var(--preview-accent);

    span {
      background: #c9d2e0;
    }
  }
}

.preview-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  margin-top: auto;
  font-size: 10px;
  line-height: 1;
}

.preview-btn-primary {
  padding: 5px 10px;
  border-radius: 4px;
  background: var(--preview-accent);
  color: var(--preview-on-accent);
}

.preview-btn-outline {
  padding: 4px 9px;
  border-radius: 4px;
  border: 1px solid var(--preview-accent);
  color: var(--preview-accent);
}

.preview-link {
  color: var(--preview-accent);
  text-decoration: underline;
}
</style>
